import React, { FC, useState } from "react";

import { Attachment, IAttachment } from "@/data/attachments";
import { IConsultantProfileDto } from "@/data/consultant-profiles";
import { CompletePrivateProfile, PrivatePersonUploadCv } from "@/views/components/ConsultantProfile/PrivatePerson";
import { IProfileSuggestedDataFormValues } from "@/views/components/ConsultantProfile/SuggestedData";
import { AnimatedLayoutContainer } from "@/views/components/Layout";
import { useOnboardingActions } from "@/views/Onboarding/hooks";

import { OnboardingPrivatePersonStep } from "../types";

interface IOnboardingPrivatePersonStepsProps {
  onCancel: () => void;
}

export const OnboardingPrivatePersonSteps: FC<IOnboardingPrivatePersonStepsProps> = props => {
  const [step, setStep] = useState<OnboardingPrivatePersonStep>("upload-cv");
  const [profile, setProfile] = useState<IConsultantProfileDto>({
    cvs: [],
    skills: [],
    languages: [],
    roles: [],
  });
  const { privateProfileQuickSetup } = useOnboardingActions();

  const setCvs = (cvs: IAttachment[]) => {
    setProfile(prevProfile => ({ ...prevProfile, cvs }));
  };

  const handleCompleteProfileCancel = () => {
    setStep("upload-cv");
  };

  const handleCvParsed = (cv?: Attachment) => {
    setCvs(cv ? [cv] : []);
    setStep("complete-profile");
  };

  const handleCompleteProfileValuesChange = (values: IProfileSuggestedDataFormValues) => {
    setProfile(prevProfile => ({ ...prevProfile, ...values }));
  };

  const handleSkipCV = () => {
    setCvs([]);
    setStep("complete-profile");
  };

  return (
    <>
      {step === "upload-cv" && (
        <AnimatedLayoutContainer size="md" showLogo>
          <PrivatePersonUploadCv
            profile={profile}
            onSkipCV={handleSkipCV}
            onSkipQuickSetup={privateProfileQuickSetup()}
            onCancel={props.onCancel}
            onCvParsed={handleCvParsed}
          />
        </AnimatedLayoutContainer>
      )}

      {step === "complete-profile" && (
        <AnimatedLayoutContainer size="lg">
          <CompletePrivateProfile
            profile={profile}
            onCancel={handleCompleteProfileCancel}
            isCvUploaded={profile.cvs && profile.cvs.length > 0}
            onValuesChange={handleCompleteProfileValuesChange}
          />
        </AnimatedLayoutContainer>
      )}
    </>
  );
};
